import { render, staticRenderFns } from "./pass-editor.vue?vue&type=template&id=185c7684&scoped=true&"
import script from "./pass-editor.vue?vue&type=script&lang=js&"
export * from "./pass-editor.vue?vue&type=script&lang=js&"
import style0 from "./pass-editor.vue?vue&type=style&index=0&id=185c7684&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c7684",
  null
  
)

export default component.exports